// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__27M2s","box":"WorkspacesBox_box__q2F-F","node":"WorkspacesBox_node__3zxUo"};